// @flow
import definePermission from './definePermission';

export const Guest = definePermission().complies(user => !user.authenticated);

export const Authenticated = definePermission().complies(
  user => user.authenticated
);

export const HomieUser = definePermission()
  .is(Authenticated)
  .complies(user => user.tenantType === 'homie');

export const REMCUser = definePermission()
  .is(Authenticated)
  .complies(user => user.tenantType === 're_management_company');

export const REMCAdmin = definePermission()
  .is(Authenticated)
  .is(REMCUser)
  .hasRoles('re_management_company_admin');

export const Admin = definePermission()
  .is(Authenticated)
  .hasRoles('admin');

export const RegularCustomerSucess = definePermission()
  .is(Admin)
  .complies(user => !user.is_team_leader);

export const ExternalUser = definePermission()
  .is(Authenticated)
  .hasRoles('user')
  .complies(user => user.tenantType === 'external');

export const hasRoles = (roles: Array<string>): boolean =>
  definePermission()
    .is(Authenticated)
    .hasRoles(roles);

export const AdminUser = definePermission()
  .is(Authenticated)
  .hasRoles('admin')
  .complies(user => user.tenantType === 'homie');
